<div class="button button-default" (click)="onClick()" [ngClass]="{ red: color === 'red', green: color === 'green', white: color === 'white' }">
  <div class="button-wrapper">
    <button>
      {{ label }}
    </button>
  </div>
</div>
